import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 20 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.64 11.82c-.26 0-.51-.1-.71-.29l-3-3a.996.996 0 1 1 1.41-1.41l2.29 2.29 7.29-7.29a.996.996 0 1 1 1.41 1.41l-8 8c-.2.2-.45.29-.71.29h.02Z"
      />
      <path
        fill="currentColor"
        d="M9.12 17.93c-.89 0-1.8-.13-2.7-.4C3.21 16.57.88 14.08.2 10.87c-.68-3.21.42-6.43 2.94-8.62C5.69.05 9.05-.58 12.15.55a.996.996 0 1 1-.69 1.87c-2.4-.88-5.02-.38-7 1.33-1.97 1.71-2.83 4.2-2.3 6.68.53 2.48 2.34 4.42 4.84 5.17 2.52.75 5.12.13 6.95-1.67.39-.39 1.03-.38 1.41 0 .39.39.38 1.03 0 1.41a8.822 8.822 0 0 1-6.22 2.56l-.02.03Z"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
